export default function AboutMe() {
  return (
    <section id="AboutMe" className="about--section">
      <div className="about--section--img">
        <img src="./img/about-me.JPG" alt="About Me" />
      </div>
      <div className="hero--section--content--box about--section--box">
        <div className="hero--section--content">
          <p className="section--title">About</p>
          <h2 className="skills-section--heading">About Me</h2>
          <div className="about--content">
            <p className="hero--section-description">
              I'm a passionate Computer Science student at Brigham Young University, currently working as a Software Developer at More Good Foundation where I lead the development of "Lia", an AI-powered web application. I specialize in full-stack software development with expertise in React, TypeScript, Node.js, and AI technologies including LangChain and LLMs.
            </p>
            <p className="hero--section-description">
              I believe in the power of teamwork and effective communication. As a hard worker, self-motivated individual, and quick learner, I'm always eager for new opportunities to grow and improve my skills. I have experience in both web and mobile development, with a strong foundation in cloud services and database management.
            </p>
            <div className="about--highlights">
              <div className="highlight--item">
                <span className="highlight--icon">🎓</span>
                <span className="highlight--text">Computer Science Student at BYU (GPA: 3.87)</span>
              </div>
              <div className="highlight--item">
                <span className="highlight--icon">💼</span>
                <span className="highlight--text">Software Developer at More Good Foundation</span>
              </div>
              <div className="highlight--item">
                <span className="highlight--icon">🤖</span>
                <span className="highlight--text">AI/ML Development with LangChain & LLMs</span>
              </div>
              <div className="highlight--item">
                <span className="highlight--icon">🎵</span>
                <span className="highlight--text">Musician (Piano, Violin, Harmonica)</span>
              </div>
              <div className="highlight--item">
                <span className="highlight--icon">🌍</span>
                <span className="highlight--text">Fluent in English, Mandarin, and Cantonese</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
